/**
 * @generated SignedSource<<a159da7cbbe0da00a48e705e922f7f33>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$variables = Record<PropertyKey, never>;
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$data = {
  readonly areaBackgroundRules: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery = {
  response: addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$data;
  variables: addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AreaBackgroundRuleTool",
    "kind": "LinkedField",
    "name": "areaBackgroundRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "0ff99bd58ba0986dd20d6798136c25e2",
    "id": null,
    "metadata": {},
    "name": "addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery",
    "operationKind": "query",
    "text": "query addAreaBackgroundRulePanel_AreaBackgroundRulesListForAddQuery {\n  areaBackgroundRules {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "f509934ccac5004c8db0cfbb8b7ee01f";

export default node;
